import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Google from '../pics/g.png';
import Facebook from '../pics/fb.svg';
import Cross from '../pics/svg/cross.svg';
import firebase from 'firebase/app';
import Error from '../popups/error';
import "./login.css";

class Login extends Component {

    constructor(props) {
        super(props)
        this.state = {
            email: '',
            password: '',
            emailEmpty: true,
            passwordEmpty: true
        }
        this.hideLoginButton = this.hideLoginButton.bind(this);
        this.showLoginButton = this.showLoginButton.bind(this);
        this.auth = firebase.auth();
        this.googleProvider = new firebase.auth.GoogleAuthProvider();
        this.facebookProvider = new firebase.auth.FacebookAuthProvider();
        this.emailProvider = new firebase.auth.EmailAuthProvider();
    }

    componentDidMount() {
        (!this.state.emailEmpty && !this.state.passwordEmpty) ? this.showLoginButton() : this.hideLoginButton()
    }

    componentDidUpdate() {
        (!this.state.emailEmpty && !this.state.passwordEmpty) ? this.showLoginButton() : this.hideLoginButton()
    }

    hideLoginButton() {
        document.querySelector('.Login').style.opacity = 0;
        document.querySelector('.Login').style.pointerEvents = 'none';
    }
    showLoginButton() {
        if (document.querySelector('.login-wrapper').style.pointerEvents === "all") {
            document.querySelector('.Login').style.opacity = 1;
            document.querySelector('.Login').style.pointerEvents = 'all'; 
        }
    }

    closeLogin = () => {
        document.querySelector('.login-wrapper').style.transform = "scale(0.8)"
        document.querySelector('.login-wrapper').style.opacity = 0
        document.querySelector('.login-wrapper').style.pointerEvents = "none"
        this.hideLoginButton();
    }
    onSignUpClick = () => {
        this.closeLogin();
        document.querySelector('.signup-wrapper').style.transform = "scale(1)"
        document.querySelector('.signup-wrapper').style.opacity = 1
        document.querySelector('.signup-wrapper').style.pointerEvents = "all"
    }

    googleLogin = () => {
        var user = firebase.auth().currentUser;

        if (user) {
        } else {
            this.auth.signInWithPopup(this.googleProvider).catch(function (error) {
                ReactDOM.render(<Error oops={error} />, document.querySelector('.error-container'));
                document.querySelector('.error').classList.add('show')
                setTimeout(() => {
                    document.querySelector('.error').classList.remove('show')
                }, 7000);
            });
            this.closeLogin();
        }
    }
    facebookLogin = () => {
        var user = firebase.auth().currentUser;

        if (user) {
        } else {
            this.auth.signInWithPopup(this.facebookProvider).then(function (result) {
                if (result.credential) {
                    // This gives you a Facebook Access Token. You can use it to access the Facebook API.
                    // var token = result.credential.accessToken;
                    // ...
                }
            }).catch(function (error) {
                ReactDOM.render(<Error oops={error} />, document.querySelector('.error-container'));
                document.querySelector('.error').classList.add('show')
                setTimeout(() => {
                    document.querySelector('.error').classList.remove('show')
                }, 7000);
            });
            this.closeLogin();
        }
    }

    handleEmailChange = (event) => {
        event.target.value === '' ? this.setState({ emailEmpty: true }) : this.setState({ emailEmpty: false })
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    handlePasswordChange = (event) => {
        event.target.value === '' ? this.setState({ passwordEmpty: true }) : this.setState({ passwordEmpty: false })
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    emailLogin = () => {
        let email = this.state.email;
        let password = this.state.password;
        firebase.auth().signInWithEmailAndPassword(email, password).catch(function (error) {
            ReactDOM.render(<Error oops={error} />, document.querySelector('.error-container'));
            document.querySelector('.error').classList.add('show')
            setTimeout(() => {
                document.querySelector('.error').classList.remove('show')
            }, 7000);
        });
        this.closeLogin();
    }

    handleEnter = (event) => {
        if (event.keyCode === 13 && !this.state.emailEmpty && !this.state.passwordEmpty) {
            event.preventDefault();
            this.emailLogin();
        }
    }

    render() {
        return (
            <div className="login-wrapper">
                <div className="login-container">
                    <img onClick={this.closeLogin} className="close" src={Cross} alt="X"/>
                    <div className="login-heading">Login</div>
                    <div className="accounts-container">
                        <button onClick={this.googleLogin} className="google-login">
                            <img src={Google} alt="Google"/>
                            <span>Continue with Google</span>
                        </button>
                        <button onClick={this.facebookLogin} className="facebook-login">
                            <img src={Facebook} alt="Facebook"/>
                            <span>Continue with Facebook</span>
                        </button>
                    </div>
                    <div className="email-container">
                        <input
                            autoComplete="on"
                            onChange={this.handleEmailChange}
                            onKeyUp={this.handleEnter}
                            className="emailInput"
                            name="email"
                            type="email"
                            placeholder="Email" />
                        <input
                            autoComplete="on"
                            onChange={this.handlePasswordChange}
                            onKeyUp={this.handleEnter}
                            className="passwordInput"
                            name="password"
                            type="password"
                            placeholder="Password" />
                        <div className="buttons">
                            <span>Forgot your password?</span>
                            <button onClick={this.emailLogin} className="Login">Login</button>
                        </div>
                    </div>
                    <div className="no-account">
                        <span>Haven't got an account yet?</span>
                        <span onClick={this.onSignUpClick} className="no-account-sign-up">Sign Up</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default Login;
